// packages/web/src/api/change-log/keys.ts

export const changeLogKeys = {
  all: ["change-log"] as const,
  me: (userId: string, weekISO?: string, entityType?: string) =>
    [...changeLogKeys.all, "me", userId, { weekISO, entityType }] as const,
};
